export const FAQ_ITEMS = [
  {
    question: 'What is WebForms.biz?',
    answer: 'WebForms.biz is a form builder for marketing, sales, operations, and agency teams. Build forms visually, publish them with a share link or embed, and review responses in one workspace without writing code.',
  },
  {
    question: 'How does pricing work, and is there a money-back guarantee?',
    answer: 'There is a free plan plus paid plans with monthly or annual billing. All paid plans include a 14-day free trial with no credit card required and a 30-day money-back guarantee on the initial paid subscription purchase. Each plan shows its form, submission, seat, and storage limits before you choose; review the Terms for the full refund conditions.',
  },
  {
    question: 'What happens when I reach my submission limit?',
    answer: 'Your plan’s monthly submission allowance is shown in the pricing cards and dashboard. If your forms are growing beyond that allowance, move to a higher-capacity plan before the next busy period.',
  },
  {
    question: 'Can I import forms from another tool?',
    answer: 'WebForms.biz does not currently advertise a direct form-import workflow. You can start from a template or build a form from scratch with the drag-and-drop editor.',
  },
  {
    question: 'Is WebForms.biz established and reliable?',
    answer: 'WebForms.biz is a live product you can evaluate on its free plan. Review the product, Terms, and Privacy Policy for your requirements. We do not publish an unverified founding date, uptime percentage, or customer count.',
  },
  {
    question: 'How does pricing compare with Typeform or Jotform?',
    answer: 'Competitor pricing and limits change, so compare each provider’s current offer directly. WebForms.biz publishes its form, submission, seat, storage, and feature limits on the pricing section; the comparison pages explain which product areas to check.',
  },
  {
    question: 'How many templates are available?',
    answer: 'The template gallery is updated as new starting points are added. Browse the current gallery to find a form close to your use case, then customize it in the builder.',
  },
  {
    question: 'Can I connect other tools and collect payments?',
    answer: 'Yes. Forms can connect through webhooks, Zapier, and the REST API where your plan includes API access. Payment forms use Stripe for checkout, and forms can be published by share link or embed.',
  },
];
